import OverviewTab from "./OverviewTab";
import { Tabs } from "@shared/ui/tabs";

import { Button } from "@shared/ui/button";
import { useNavigate } from "react-router-dom";
import { Edit, Plus } from "lucide-react";
import { PageHeader } from "@shared/components/PageHeader";
import TarrifList from "../rate/components/list/list";
import PlanList from "../plan/components/landing/PlanList";

const PlansAndTariffLanding = () => {
  const navigate = useNavigate();

  const handleAdd = (name: string) => {
    if (name === "tarrif") {
      navigate("/plan-tarrif/tariff/create");
    }
    if (name === "plan") {
      navigate("/plan-tarrif/plan/create");
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="mb-8">
        <h1 className="page-title">Plans & Tariffs</h1>
        <p className="page-subtitle">Manage your plans and tariffs.</p>
      </div>
      <Tabs
        defaultValue="overview"
        urlMapping={{
          overview: "overview",
          tariff: "tariff",
          plans: "plans",
        }}
        tabComponents={{
          overview: {
            label: "Overview",
            component: <OverviewTab />,
          },
          tariff: {
            label: "Tariff",
            component: (
              <div>
                <div className="mb-4 flex justify-between w-full">
                  <PageHeader
                    title="Manage Tariffs"
                    subtitle="Define, update, and manage utility tariffs and rate structures."
                  />
                  <div className="flex items-center gap-3">
                    <Button
                      size="sm"
                      variant={"outline"}
                      onClick={() => navigate("/plan-tarrif/tariff/bulk-edit")}
                    >
                      <Edit className="h-4 w-4" />
                      Bulk Edit
                    </Button>
                    <Button
                      size="sm"
                      className="gap-1"
                      onClick={() => handleAdd("tarrif")}
                    >
                      <Plus className="h-4 w-4" />
                      Add Tarrif
                    </Button>
                  </div>
                </div>
                <TarrifList />
              </div>
            ),
          },
          plans: {
            label: "Plans",
            component: (
              <div>
                <div className="mb-4 flex justify-between w-full">
                  <PageHeader
                    title="Manage Plans"
                    subtitle="Create, update, and organize consumer service plans."
                  />
                  <div className="flex items-center gap-3">
                    <Button
                      variant="outline"
                      onClick={() => navigate("/plan-tarrif/plan/bulk-edit")}
                    >
                      Bulk Edit
                    </Button>
                    <Button
                      className="gap-1"
                      onClick={() => handleAdd("plan")}
                    >
                      <Plus className="h-4 w-4" />
                      Add Plan
                    </Button>
                  </div>
                </div>
                <PlanList />
              </div>
            ),
          },
        }}
        tabsListClassName="grid grid-cols-3"
        idPrefix="plans-tab"
        className="w-full"
      />
    </div>
  );
};

export default PlansAndTariffLanding;
